import { OPERATOR } from "./logic";

export type Field = {
    id: string;
    title: string;
    type: string;
    index: number; // This is the index of the field in the form starting from 1
    choices?: { id: string; label: string }[];
};

export type Action =
    | AddLogicAction
    | RemoveLogicAction
    | AddBranchAction
    | AddGroupAction
    | AddRuleAction
    | EditLogicAction
    | EditBranchAction
    | EditRuleAction
    | RemoveBranchAction
    | RemoveGroupAction
    | RemoveRuleAction
    | DuplicateBranchAction
    | DuplicateGroupAction
    | SetActiveFieldIdAction
    | AddFieldAction
    | ChangeFieldTitleAction
    | ChangeFieldIndexAction
    | ChangeFieldOrderAction
    | RemoveFieldAction
    | ResetLogicAction
    | ReorderLogicsAction;

export enum ActionType {
    ADD_LOGIC = "ADD_LOGIC",
    ADD_BRANCH = "ADD_BRANCH",
    ADD_GROUP = "ADD_GROUP",
    ADD_RULE = "ADD_RULE",

    EDIT_LOGIC = "EDIT_LOGIC",
    EDIT_BRANCH = "EDIT_BRANCH",
    EDIT_RULE = "EDIT_RULE",

    REMOVE_LOGIC = "REMOVE_LOGIC",
    REMOVE_BRANCH = "REMOVE_BRANCH",
    REMOVE_GROUP = "REMOVE_GROUP",
    REMOVE_RULE = "REMOVE_RULE",

    DUPLICATE_BRANCH = "DUPLICATE_BRANCH",
    DUPLICATE_GROUP = "DUPLICATE_GROUP",

    SET_ACTIVE_FIELD_ID = "SET_ACTIVE_FIELD_ID",

    ADD_FIELD = "ADD_FIELD",
    CHANGE_FIELD_TITLE = "CHANGE_FIELD_TITLE",
    CHANGE_FIELD_INDEX = "CHANGE_FIELD_INDEX",
    CHANGE_FIELD_ORDER = "CHANGE_FIELD_ORDER",
    REMOVE_FIELD = "REMOVE_FIELD",

    RESET_LOGIC = "RESET_LOGIC",
    REORDER_LOGICS = "REORDER_LOGICS",
}

export type AddLogicAction = {
    type: ActionType.ADD_LOGIC;
    payload: {
        fieldId: string;
        newFields: any[];
    };
};

export type RemoveLogicAction = {
    type: ActionType.REMOVE_LOGIC;
    payload: {
        fieldId: string;
    };
};

export type ReorderLogicsAction = {
    type: ActionType.REORDER_LOGICS;
    payload: {
        oldFields: Field[];
        newFields: Field[];
    };
};

export type AddBranchAction = {
    type: ActionType.ADD_BRANCH;
    payload: {
        fieldId: string;
    };
};

export type AddGroupAction = {
    type: ActionType.ADD_GROUP;
    payload: {
        branchId: string;
    };
};

export type AddRuleAction = {
    type: ActionType.ADD_RULE;
    payload: {
        groupId: string;
        sourceId: string;
        operator: OPERATOR;
        expectedValue: string;
    };
};

export type EditLogicAction = {
    type: ActionType.EDIT_LOGIC;
    payload: {
        fieldId: string;
        defaultTargetId: string;
    };
};

export type EditBranchAction = {
    type: ActionType.EDIT_BRANCH;
    payload: {
        branchId: string;
        targetId: string;
    };
};

export type EditRuleAction = {
    type: ActionType.EDIT_RULE;
    payload: {
        ruleId: string;
        sourceId?: string;
        operator?: OPERATOR;
        expectedValue?: string;
    };
};

export type RemoveBranchAction = {
    type: ActionType.REMOVE_BRANCH;
    payload: {
        branchId: string;
    };
};

export type RemoveGroupAction = {
    type: ActionType.REMOVE_GROUP;
    payload: {
        groupId: string;
    };
};

export type RemoveRuleAction = {
    type: ActionType.REMOVE_RULE;
    payload: {
        ruleId: string;
    };
};

export type DuplicateBranchAction = {
    type: ActionType.DUPLICATE_BRANCH;
    payload: {
        branchId: string;
    };
};

export type DuplicateGroupAction = {
    type: ActionType.DUPLICATE_GROUP;
    payload: {
        groupId: string;
    };
};

export type SetActiveFieldIdAction = {
    type: ActionType.SET_ACTIVE_FIELD_ID;
    payload: {
        fieldId: string;
    };
};

export type AddFieldAction = {
    type: ActionType.ADD_FIELD;
    payload: Field;
};

export type ChangeFieldTitleAction = {
    type: ActionType.CHANGE_FIELD_TITLE;
    payload: {
        fieldId: string;
        title: string;
    };
};

export type ChangeFieldIndexAction = {
    type: ActionType.CHANGE_FIELD_INDEX;
    payload: {
        fieldId: string;
        newIndex: number;
    };
};

export type ChangeFieldOrderAction = {
    type: ActionType.CHANGE_FIELD_ORDER;
    payload: {
        newFields: Field[];
    };
};

export type RemoveFieldAction = {
    type: ActionType.REMOVE_FIELD;
    payload: {
        fieldId: string;
    };
};

export type ResetLogicAction = {
    type: ActionType.RESET_LOGIC;
    payload: {};
};
